import React, { useState, useEffect } from 'react';
import api from '../utils/api';

interface Transport {
  id: number;
  type: 'load' | 'vehicle';
  origin: string;
  destination: string;
  price: string | null;
  contact_phone: string;
  description: string | null;
  created_at: string;
}

const Transport: React.FC = () => {
  const [transports, setTransports] = useState<Transport[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('🔄 در حال بارگذاری درخواست‌های بار و ماشین...');
    
    api.get('/test-full.php?action=api-transport')
      .then(response => {
        console.log('📦 پاسخ کامل API:', response);
        console.log('📦 response.data:', response.data);
        
        const data = response.data;
        console.log('📦 data.success:', data.success);
        console.log('📦 data.data:', data.data);
        console.log('📦 آیا آرایه است؟', Array.isArray(data.data));
        
        if (data.success && Array.isArray(data.data)) {
          console.log('✅ تعداد درخواست‌ها:', data.data.length);
          setTransports(data.data);
        } else {
          setError('داده‌ها به درستی دریافت نشدند.');
          console.error('❌ ساختار داده‌ها نامعتبر است:', data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('❌ خطا در بارگذاری درخواست‌ها:', err);
        setError('خطا در بارگذاری درخواست‌ها: ' + err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="loading">در حال بارگذاری...</div>;
  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>بار و ماشین</h1>
        </div>
      </div>
      <section style={{ padding: '20px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '25px' }}>
            {transports.length > 0 ? (
              transports.map(t => (
                <div key={t.id} style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
                  <span style={{ display: 'inline-block', padding: '3px 12px', borderRadius: '20px', fontSize: '12px', background: t.type === 'load' ? '#e8f5e9' : '#e3f2fd', color: t.type === 'load' ? '#2e7d32' : '#0d47a1' }}>
                    {t.type === 'load' ? 'بار' : 'ماشین'}
                  </span>
                  <h3 style={{ margin: '10px 0' }}>{t.origin} → {t.destination}</h3>
                  <p>{t.description || ''}</p>
                  <p>قیمت: {t.price ? new Intl.NumberFormat('fa-IR').format(Number(t.price)) + ' تومان' : 'توافقی'}</p>
                  <p>تماس: {t.contact_phone}</p>
                </div>
              ))
            ) : (
              <p>هیچ درخواستی ثبت نشده است.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Transport;